/** @module Apparel/Material3DForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/ViewRef",
	"csi/xml",
	"csi/xml/Query",
	"./MaterialForm"
	], function(declare,lang,Action,Field,ViewRef,xml,Query,MaterialForm) {
	var PRODUCT_COLORS = "ProductColors";

	return declare(MaterialForm, {
			/*
			 * @override
			 * Add store action for product colors in form for go to dialog
			 */
			getFieldStore: function(field, value) {
				var store = this.inherited(arguments);

				if(field.getControlName() === PRODUCT_COLORS) {
					// create view for goto dialog
					store.action = lang.mixin(new Action(),{
						m_fixedQuery: new Query().Attr("Active", xml.OP_EQUALS, "true"),
						m_viewRef: lang.mixin(new ViewRef(), {
								m_id: PRODUCT_COLORS,
								m_url: field.m_relationship.m_url
						})
					});
				}

				return store;
			},

			/**
			 * Update keep existing field visibility
			 * @param {def.View} defView
			 * @param {Field} field
			 * @param {Any} value
			 */
			_onChangeProductTypeUpdateKeepExisting: function(defView, field, value) {
				const colorMaterialField = defView.getField("ColorMaterial");
				const materialTypeNode = xml.isValidURL(value) && (this.cacheView.getNode(value) || this.cacheView.addNode(value));
				const configUrl = materialTypeNode && materialTypeNode.ProductionConfig;
				const productionConfigNode = this.cacheView.getNode(configUrl) || this.cacheView.addNode(configUrl);
				if (productionConfigNode && productionConfigNode.HasColor) {
					this.setFieldDisabled(colorMaterialField, false);
				} else {
					this.setFieldValue(colorMaterialField, false);
					this.setFieldDisabled(colorMaterialField, true);
				}
			}
	});
});